const de = {
  title: { awpm: 'AWPM-Modulkatalog', fwpm: 'FWPM-Modulkatalog' },
  lecturer: 'Dozent',
  lecturers: 'Dozenten',
  courseOfStudy: 'Studiengang',
  faculty: 'Verantwortlicher Studiengang',
  moduleResponsible: 'Modulverantwortlicher',
  moduleResponsibleTooltip:
    'Wird benötigt, damit Modul vollständig ist. Kann allerdings ohne bereits als Entwurf gespeichert werden.',
  semester: 'Semester',
  grouping: 'Gruppe',
  sorting: 'Kategorie',
  awpm: 'awpm',
  fwpm: 'fwpm',
  activated: 'Aktiviert',
  deactivated: 'Deaktiviert',
  noModule: 'Derzeit gibt es keine Module',
  seatsAvailable: 'Plätze',
  seatConfiguration: 'gesamt, davon {{config}}',
  goBackFromDetailView: 'Zurück zu den Modulen',
  goBackToSelections: 'Zurück zur Wahl',
  isNotTakingPlace: 'Nicht zustande gekommen',
  takesPlace: 'Zustande gekommen',
  isNotTakingPlaceButton: 'Findet nicht statt',
  takesPlaceButton: 'Findet statt',
  isNotTakingPlaceDialogTitle: 'Nicht zustande gekommen',
  isNotTakingPlaceDialoginfo:
    'Wollen Sie den Zustand des Moduls wirklich auf nicht zustande gekommen setzen? Hierbei werden alle Teilnehmer des Moduls über diese Änderung per E-Mail benachrichtigt.',
  deactivate: 'Deaktivieren',
  activate: 'Aktivieren',
  draft: 'Entwurf',
  incomplete: 'Unvollständig',
  complete: 'Vollständig',
  signOut: 'Ausschreiben',
  signIn: 'Einschreiben',
  position: 'Position',
  studentNumber: 'Matrikelnummer',
  registeredParticipants: 'Angemeldete Teilnehmer',
  admissionCriteria: 'Zulassungskriterien',
  listOfParticipants: 'Teilnehmerliste',
  listOfDischarged: 'Austragungen',
  showStudentsWithEnoughDesiredModules: 'Zeige Studenten die bereits genügend Module haben',
  explanationOfSeatDistributionTitle: 'Hinweis zu den Wahleinstellungen',
  explanationOfSeatDistributionText:
    'Wenn bei dem Feld "Plätze" eine Zahl eingetragen wird, so wird diese Anzahl an Plätzen fest für die angegebenen Studiengänge reserviert. Wird in das Feld eine 0 eingetragen oder das Feld leer gelassen, so sind keine Plätze für die konfigurieren Studiengänge reserviert. Dies hat zur Folge, dass die Studierenden zunächst auf andere Module mit reservierten Plätzen verteilt werden und erst anschließend auf dieses Modul.',
  addStudent: 'Student hinzufügen',
  pauseSuccessor: 'Nachrücken pausieren',
  resumeSuccessor: 'Nachrücken fortsetzen',
  dischargeDialogText: 'Der nächste Student aus der Warteliste wird nachrücken.',
  dischargeDialogTextNotMovingUp:
    'Das Nachrückverfahren ist aktuell deaktiviert/pausiert. Es wird kein Student aus der Warteliste nachrücken.',
  dischargeDialogTextPausedSuccesor:
    'Das Nachrückverfahren ist aktuell deaktiviert/pausiert. Möchten Sie dies einmalig aktivieren und nun für dieses Modul den ersten Studenten aus der Warteliste (insofern vorhanden) nachrücken lassen?',
  dischargeConfirmOnlyDischarge: 'Nein (Nur austragen)',
  dischargeConfirmMoveUp: 'Ja (Nachrücken)',
  table: {
    mtrNumber: 'Matrikelnummer',
    firstName: 'Vorname',
    lastName: 'Nachname',
    courseOfStudy: 'Studiengang',
    semester: 'Semester',
    wishlistPosition: 'Wunschlistenposition',
    drawnNumber: 'Losschlüssel',
    actions: 'Aktionen'
  },
  setStateConfirm: {
    setActiveTitle: 'Wirklich Aktivieren?',
    setInavctiveTitle: 'Wirklich deaktivieren',
    setActive: 'Wollen Sie das Modul aktivieren?',
    setInactive: 'Wollen Sie das Modul deaktivieren?'
  },
  alerts: {
    failedLoading: 'Module konnten nicht geladen werden',
    failedLoadingModule: 'Modul konnte nicht gealden werden',
    failedLoadingConfiguration: 'Konfiguration konnte nicht geladen werden',
    failedLoadingCourseOfStudy: 'Studiengänge konnten nicht geladen werden',
    failedLoadingPrioritization: 'Priorisierungen konnten nicht geladen werden',
    failedLoadingCourses: 'Die Kurse konnten nicht geladen werden',
    deleteFailed: 'Das Modul konnte nicht gelöscht werden',
    deleteSuccessful: 'Das Modul wurde erfolgreich gelöscht',
    successfulCreate: 'Das Modul wurde erfolgreich erstellt',
    failedCreate: 'Erstellen des Moduls nicht möglich',
    successfulUpdate: 'Das Modul wurde erfolgreich aktualisiert',
    failedUpdate: 'Das Modul konnte nicht aktualisiert werden',
    failedAttachmentUpload: 'Die Dateien konnten nicht hochgeladen werden',
    deleteParConfSuccessful: 'Die Konfiguration wurde erfolgreich gelöscht',
    deleteParConfFailed: 'Die Konfiguration konnte nicht gelöscht werden',
    changeStateFailed: 'Der Status des Moduls konnte nicht geändert werden',
    changeStateSuccssful: 'Der Status des Moduls wurde erfolgreich geändert',
    dischargeStudentFailed: 'Die Austragung aus dem Modul ist fehlgeschlagen',
    dischargeStudentSuccessful: 'Die Austragung aus dem Modul war erfolgreich',
    addStudentSuccessful: 'Der Student wurde erfolgreich zur Wahl hinzugefügt',
    addStudentFailed: 'Der Student konnte nicht zu Wahl hinzugefügt werden',
    addStudentInvalidForm: 'Bitte wählen Sie einen Benutzer zum Hinzufügen aus.',
    notAShibUser:
      'Es handelt sich nicht um einen Shibboleth Benutzer. Daher muss noch ein Studiengang ausgewählt werden',
    emailHasToBeEntered:
      'Es muss eine Email eingegeben werden, bevor ein Studiengang ausgewählt werden kann',
    noLotteryToAddTo:
      'Die Studenten können erst hinzugefügt werden, sobald eine Wahl sich im Nachrückverfahren befindet.',
    noSuccessorPossible:
      'Das Nachrückerverfahren kann nur pausiert werden, wenn sich eine Wahl im Nachrückverfahren befindet.',
    successfulPauseDischarge:
      'Sie haben das Nachrückverfahren für dieses Modul bis auf Weiteres deaktiviert. Bitte beachten Sie, dass keine Studenten nachrücken, solange Sie das Nachrückverfahren nicht wieder aktiviert haben.',
    successfulContinueDischarge:
      'Sie haben das Nachrückverfahren für dieses Modul reaktiviert und Teilnehmer rücken nun nach. Dies kann ein paar Minuten dauern. Aktualisieren Sie die Seite zu einem späteren Zeitpunkt erneut.'
  },
  steps: {
    SubjectCategory: 'Kategorie',
    GeneralInfo: 'Allgemeine Info',
    Participants: 'Teilnehmer',
    PrioritizationAndApproval: 'Priorisierung & Zulassung',
    ReviewAndCreate: 'Überprüfung & Publikation'
  },
  deleteConfirm: {
    title: 'Wirklich löschen?',
    message: 'Wollen Sie dieses Modul wirklich löschen?'
  },
  create: {
    title: { awpm: 'Neues AWPM', fwpm: 'Neues FWPM' },
    category: {
      selectCategory: 'Kategorie wählen',
      awpm: 'Wahlmodul und Wahlpflichtmodul',
      fwpm: 'Modulwissenschaftliche Wahlpflichtmodule'
    },
    GeneralInfo: {
      name: 'Modulbezeichnung',
      moduleOfficer: 'Modulbeauftragter',
      salutationMale: 'Herr',
      salutationFemale: 'Frau',
      salutationOther: 'Divers',
      lecturer: {
        title: 'Dozent',
        salutation: 'Anrede',
        firstName: 'Vorname',
        lastName: 'Nachname'
      },
      grouping: {
        title: 'Gruppe & Sortierung',
        grouping: 'Gruppe',
        sorting: 'Sortierung'
      },
      description: 'Beschreibung',
      attachments: 'Dateien',
      attachmentPlaceholder: 'Dateien hochladen (pdf, zip)'
    },
    periodsAndParticipants: {
      participants: {
        title: 'Teilnehmer',
        min: 'Min. Gesamtteilnehmer',
        max: 'Max. Gesamtteilnehmer'
      },
      isMoveUpActive: 'Nachrückverfahren aktiv',
      takingPlace: 'Findet statt'
    },
    prioritizationAndApproval: {
      selectAll: 'Alle auswählen',
      configWarning:
        'Alle Studiengangskonfigurationen ohne reservierte Plätze bleiben unberücksichtigt!',
      title:
        'Bitte beachten Sie, dass die gewählten Studiengänge mit Ihnen die Wahl teilen müssen, damit die Studenten Ihre FWPMs auch sehen können. Bitte sprechen Sie sich daher mit den betroffenen C-Admins bzgl. einem Termin ab!',
      addNew: 'Studiengang hinzufügen',
      altLeastOneConfigurationRequired:
        'Es muss die Priorisierung & Zulassung für mindestens einen Studiengang definiert werden.',
      participants: 'Gesamtteilnehmer',
      openSeats: 'noch nicht reserviert',
      reservedMoreSeats: 'zu viel reserviert',
      participantConfiguration: {
        courseOfStudy: 'Studiengang',
        courseOfStudyIsGlobal: 'Fächerübergreifend',
        seats: 'Plätze',
        admissionCriteria: 'Zulassungskriterium',
        subjectType: 'Wählbar als',
        prioritization: 'Priorisierung',
        prioritizationEmpty: 'Priorisierung auswählen...',
        customPrioritization: 'Individuelle Priorisierung',
        customPrioEmpty: 'Individuelle Priorisierung erstellen...',
        isGlobal: 'Modul für alle Studiengänge wählbar',
        isGlobalError: 'Es kann nur eine fächerübergreifende Konfiguration geben',
        excludeCourses: 'Studiengänge ausschließen',
        chooseCoursestoExclude: 'Auszuschließende Studiengänge auswählen',
        bachelor: 'Bachelor',
        master: 'Master'
      },
      distributeSeats: 'Restplatzverteilung',
      distributingSeats: 'Restplätze werden verteilt',
      automaticSeatDistribution: 'Sitze automatisch verteilen',
      awpmDistributingSeats:
        'Restliche Plätze auf alle Studenten verteilen.\n\nHierbei werden alle restlichen Plätze nach Algorithmus an alle weiteren Studenten verteilt, inkl. der Studenten die einem Studiengang angehören, der bereits feste Plätze reserviert bekommen hat.',
      fwpmDistributingSeats:
        'Restliche Plätze auf alle weiteren Studenten aus zugelassenen Studiengängen verteilen.\n\nHier werden alle restlichen Plätze nach Algorithmus an alle weiteren Studenten der Studiengänge verteilt, die bereits zugelassen und feste Plätze in dem Modul bekommen haben. Nicht an Studenten ALLER verfügbaren Studiengänge.',
      distributeEvenly: 'Gleichmäßige Verteilung unter den teilnehmenden Studiengängen',
      fillUpByKey: 'Auffüllen mit Studierenden der teilnehmenden Studiengänge nach Losschlüssel'
    },
    modulePreview: {
      title: 'Titel',
      lecturer: 'Dozent',
      category: 'Kategorie',
      faculty: 'FÜ',
      group: 'Gruppe',
      interdisciplinary: 'Fachübergreifend'
    }
  },
  edit: {
    title: { awpm: 'AWPM bearbeiten', fwpm: 'FWPM bearbeiten' }
  },
  status: 'Status',
  statusComplete: 'Vollständig',
  statusCompleteDraft: 'Entwurf (Vollständig)',
  statusIncomplete: 'Unvollständig',
  statusIncompleteDraft: 'Entwurf (Unvollständig)'
};

export default de;
export type ModulesTranslation = typeof de;
